import React, { useState } from "react";
import DataTable from "react-data-table-component";
import styled from 'styled-components/macro';

import { useMemo } from "react";
import { Button, Form, OverlayTrigger } from "react-bootstrap";
import { useFormik } from "formik";

import { TbGridDots } from "react-icons/tb";
import { HiChevronDown } from "react-icons/hi";
import { components } from 'react-select';
import { FileReportService } from "../../../services/FileReportService";
import { BsCloudDownloadFill } from "react-icons/bs";
import { downloadXl } from "../../../functions";
import { useEffect } from "react";
import { Tooltip } from "@mui/material";
import DetailCutomRowStyle from "../../components/DetailCutomRowStyle";
import GrayDetailCutomRowStyle from "../../components/GrayDetailCutomRowStyle";

const datatableCustomStyles = {
  rows: {
    style: {
      minHeight: '20px', // override the row height
      fontSize: '0.7em',
      fontColor: '#212529 !important',
      width: '100%'
    },
  },
  headCells: {
    style: {
      paddingLeft: '5px', // override the cell padding for head cells
      paddingRight: '5px',
      textTransform: "uppercase",
      fontSize: '0.7em',
      fontWeight: '800',
      fontColor: '#6c757d !important',
      opacity: 1,
      minHeight: "10px",
    },
  },
  cells: {
    style: {
      paddingLeft: '8px', // override the cell padding for data cells
      paddingRight: '8px',
      width: "100%",
    },
  },
  pagination: {
    style: {
      color: '#000',
      fontSize: '13px',
      minHeight: '56px',
      backgroundColor: '#fff',
      borderTopStyle: 'solid',
      borderTopWidth: '1px',
      borderTopColor: '#f2f2f2',
    },
    pageButtonsStyle: {
      borderRadius: '50%',
      height: '40px',
      width: '40px',
      padding: '8px',
      margin: '0px',
      cursor: 'pointer',
      transition: '0.4s',
      color: '#000',
      fill: '#000',
      backgroundColor: 'transparent',
      '&:disabled': {
        cursor: 'unset',
        color: '#e2e2e2',
        fill: '#e2e2e2',
      },
      '&:hover:not(:disabled)': {
        backgroundColor: '#f2f2f2',
      },
      '&:focus': {
        outline: 'none',
        backgroundColor: '#f5f5f5',
      },
    },
  },
};

function LockBoxFileReportDetails(params) {
  const { report_station, report_job_status, report_date_range, report_hour_count, user, day, year, week, month, filtering_date, clients, facilities, facility_id } = params

  const [reRenderDataTable, setRerenderDataTable] = useState(false)
  const [pageno, setPageNo] = useState(1);
  const [loading, setLoading] = useState(false);
  const [totalRows, setTotalRows] = useState(100);
  const [selectValue, setSelectValue] = useState('');
  const [colorRow, setColorRow] = React.useState({});
  const [data, setData] = useState([])
  // const [day, setDay] = useState(true)
  // const [year, setYear] = useState(false)
  // const [week, setWeek] = useState(false)
  // const [month, setMonth] = useState(false)
  const [limit, setLimit] = useState(100)
  const [searchedData, setSearchedData] = useState({
    search: "",
    client: "",
    created_date: "",
    date_range: "",
  })

  const fileReportService = new FileReportService();
  const { getLoackBoxReportDetails, downloadLoackBoxReportDetails } = fileReportService


  const handlePerRowsChange = async (newPerPage, page) => {
    setLimit(newPerPage);
    setPageNo(1)

    fetchData(1, newPerPage, report_station, report_job_status, report_date_range, report_hour_count, user, day, year, week, month, filtering_date);
    handleResetDataTable()

  };

  const handlePageChange = page => {
    setPageNo(page)
    fetchData(page, limit, report_station, report_job_status, report_date_range, report_hour_count, user, day, year, week, month, filtering_date);
  };




  const fetchData = (page, limit, station, job_status, date_range, hour_count, user, day, year, week, month, filtering_date) => {

    setLoading(true)
    getLoackBoxReportDetails(page, limit, report_station, report_job_status, report_date_range, report_hour_count, user, day, year, week, month, filtering_date, clients, facilities, facility_id).then((response) => {
      setData(response?.data?.results);
      setLimit(limit);
      setPageNo(page)
      setTotalRows(response?.data?.count);
      setLoading(false);
    });

  }

  const [expandedRows, setExpandedRows] = useState([]);


  const handleRowExpand = (row) => {
    const isRowExpanded = expandedRows.includes(row);

    setExpandedRows(isRowExpanded ? expandedRows.filter((r) => r !== row) : [...expandedRows, row]);
  };

  const columns = useMemo(
    () => [
      {
        id: 'S.NO',
        name: 'S.NO',
        selector: (row, index) => pageno == 1 ? index + 1 : (pageno - 1) * limit + index + 1,
        wrap: true,
        width: "40px",
        grow: 0.1,

      },
      {
        id: 'DEPO DATE',
        name: "DEPO DATE",
        selector: row => row?.deposit_date,
        cell: (row) =>

          <div>
            {row?.deposit_date &&

              <div className='d-flex flex-row justify-content-between align-items-center gap-2' style={{ width: '65px' }}>
                <div className='overflow-hidden text-truncate' style={{ width: "65px" }} onClick={() => handleRowClick(row)}>
                  <Tooltip disableInteractive title={row?.deposit_date} placement="top" arrow>
                    <span className="text-truncate"> {row?.deposit_date}</span>
                  </Tooltip>
                </div>
              </div>

            }
          </div>
        ,


        left: true,
        wrap: true,
        reorder: false,
        // grow: 0.1,
        expandOnRowClicked: true,
        maxWidth: '65px',
        minWidth: '65px'
      },
      {
        id: 'LBX',
        name: 'LBX',
        selector: row => row?.lock_box,
        cell: (row) => <span onClick={() => handleRowClick(row)}> {row?.lock_box}</span>,

        right: true,
        wrap: true,
        reorder: false,
        // grow: 0.1,
        maxWidth: '65px',
        minWidth: '65px'
      },
      {
        id: 'LBX FILES',
        name: 'LBX FILES',
        selector: row => row?.lock_box_files,
        cell: (row) => <span onClick={() => handleRowClick(row)}> {row?.lock_box_files}</span>,

        right: true,
        wrap: true,
        reorder: false,
        grow: 0.1,
      },
      {
        id: 'INDEX FILES',
        name: 'INDEX FILES',
        selector: row => row?.index_files,
        cell: (row) => <span onClick={() => handleRowClick(row)}> {row?.index_files}</span>,

        right: true,
        wrap: true,
        reorder: false,
        grow: 0.1,
      },
      {
        id: 'AUTO SPLIT',
        name: 'AUTO SPLIT',
        selector: row => row?.auto_split,
        cell: (row) => <span onClick={() => handleRowClick(row)}> {row?.auto_split}</span>,

        right: true,
        wrap: true,
        reorder: false,
        grow: 0.1,
      },
      {
        id: 'MANUAL SPLIT',
        name: 'MANUAL SPLIT',
        selector: row => row?.manual_split,
        cell: (row) => <span onClick={() => handleRowClick(row)}> {row?.manual_split}</span>,

        right: true,
        wrap: true,
        reorder: false,
        grow: 0.1,
      },


      {
        id: 'FILES COMPLETED',
        name: 'FILES COMPLETED',
        selector: row => row?.files_completed,
        cell: (row) => <span onClick={() => handleRowClick(row)}> {row?.files_completed}</span>,

        right: true,
        wrap: true,
        reorder: false,
        grow: 0.1,
        minWidth: '110px'

      },
      {
        id: 'FILES REJECTED',
        name: 'FILES REJECTED',
        selector: row => row?.files_rejected,
        cell: (row) => <span onClick={() => handleRowClick(row)}> {row?.files_rejected}</span>,

        right: true,
        wrap: true,
        reorder: false,
        grow: 0.1,
      },


      {
        id: 'JOB COUNT',
        name: 'JOB COUNT',
        selector: row => row?.job_count,
        cell: (row) => <span onClick={() => handleRowClick(row)}> {row?.job_count}</span>,

        right: true,
        wrap: true,
        reorder: false,
        grow: 0.1,
        // omit: isTimeCount

      },

      {
        id: '# CLAIMS',
        name: '# CLAIMS',
        selector: row => row?.claims_count,
        cell: (row) => <span onClick={() => handleRowClick(row)}> {row?.claims_count}</span>,

        right: true,
        wrap: true,
        reorder: false,
        grow: 0.1,

      },
      {
        id: '# 837 USED-JOB',
        name: '# 837 USED-JOB',
        selector: row => row?.used_837,
        cell: (row) => <span onClick={() => handleRowClick(row)}> {row?.used_837}</span>,

        right: true,
        wrap: true,
        reorder: false,
        grow: 0.1,
      },
      {
        id: '# 837 USED-CLAIMS',
        name: '# 837 USED-CLAIMS',
        selector: row => row?.used_837_claims,
        cell: (row) => <span onClick={() => handleRowClick(row)}> {row?.used_837_claims}</span>,

        right: true,
        wrap: true,
        reorder: false,
        grow: 0.1,
        minWidth: '120px'

      },
    ],

    [handleRowExpand, limit, pageno, report_hour_count, week, year],
  );

  const conditionalRowStyles = [

    {
      when: row => colorRow?.id === row?.id ? true : false,
      style: (row, index) => ({
        backgroundColor: colorRow?.id === row.id ? '#dbf4f5' : '#f2f2f2',
        color: 'black',
        // fontWeight: '550'
      }),
    },


  ];
  const handleRowClick = (row) => {
    setColorRow(row);
  };


  const searchFormik = useFormik({
    initialValues: {
      search: "",
      job_status: report_job_status,
      station: report_station,
      date_range: report_date_range,
      hour_count: report_hour_count

    },
    onSubmit: (values) => {
      console.log(values);
      handleResetDataTable()
    }
  })

  const showTooltip = (text, props) => (
    <Tooltip id="button-tooltip" {...props}>
      {text}
    </Tooltip>
  );


  const handleResetDataTable = () => {
    setRerenderDataTable(true)
  }

  const [loader, setLoader] = useState(false);
  const handleDownload = () => {
    setLoader(true)
    downloadLoackBoxReportDetails(1, limit, report_station, report_job_status, report_date_range, report_hour_count, user, day, year, week, month, filtering_date, clients, facilities, facility_id).then((response) => {
      setLoader(false)
      downloadXl(response?.data?.export_file)
    });
  }
  useEffect(() => {
    fetchData(1, limit, report_station, report_job_status, report_date_range, report_hour_count, user, day, year, week, month, filtering_date);
  }, [])

  return (
    <React.Fragment>
      <section className="section">
        <div className="row align-items-top py-2 gap-2 gap-md-5">
          <div className="col-lg-12">
            <div className="card card_background_gray">

              <Form onSubmit={searchFormik.handleSubmit} >
                <div className="d-flex justify-content-end" style={{ height: "20px" }}>

                  <div className="px-3 pt-1 d-flex flex-row justify-content-start gap-2 align-items-center flex-wrap">

                    <div>
                      <Tooltip disableInteractive title={"Download"} placement="top" arrow>
                        {!loader ?

                          <span style={{ cursor: "pointer" }} className="svg-icon svg-icon-3" onClick={() => { handleDownload() }}>
                            <BsCloudDownloadFill color="#1ba1a7" />
                          </span>
                          :
                          <span className="svg-icon svg-icon-3">
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                          </span>
                        }

                      </Tooltip>

                    </div>
                  </div>
                </div>

              </Form>


              <div className="card-body p-common" >
                <div className="table-responsive">
                  <div className="dashboardtable remove_custom_background">
                    {/* {!reRenderDataTable && */}
                    <DataTable
                      // className="custom-datatable-details"
                      paginationDefaultPage={pageno}

                      fixedHeader={true}
                      progressPending={loading}
                      data={data}
                      columns={columns}
                      pointerOnHover={true}
                      pagination
                      paginationServer
                      // highlightOnHover
                      paginationTotalRows={totalRows}
                      paginationPerPage={limit}
                      paginationRowsPerPageOptions={[25, 50, 100, 150, 200]}
                      onChangeRowsPerPage={handlePerRowsChange}
                      onChangePage={handlePageChange}
                      conditionalRowStyles={conditionalRowStyles}
                      theme="gray_detail_solarized"
                      customStyles={DetailCutomRowStyle}
                      onRowClicked={handleRowClick}
                      onRowExpandToggled={handleRowExpand}
                    // expandableRows
                    // expandOnRowClicked={false}
                    // expandableRowsHideExpander
                    // expandableRowExpanded={(row) => expandedRows.includes(row)}

                    />
                    {/* } */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </React.Fragment >
  )
}
export default LockBoxFileReportDetails




